import type { ReactNode } from "react"
import { useSectionBackground } from "@/components/website-builder/SectionBackgroundContext"

interface SectionContainerProps {
  children: ReactNode
  className?: string
  /** Optional id for scroll targets */
  id?: string
  /** NOS-119: Block-level style overrides */
  style?: Record<string, string | number | undefined>
}

/** Reusable wrapper for consistent padding/spacing across sections.
 * Vertical rhythm comes from the --nos-space-section-y token (Brand Panel "Section spacing");
 * its regular value is a clamp() matching the previous py-12 → lg:py-24 range. */
export function SectionContainer({ children, className = "", id, style }: SectionContainerProps) {
  const hasBackgroundImage = useSectionBackground()
  const bgClass = hasBackgroundImage ? "bg-transparent" : ""
  return (
    <div
      id={id}
      className={`scroll-mt-16 px-4 ${className} ${bgClass}`}
      style={{
        paddingTop: "var(--nos-space-section-y, 64px)",
        paddingBottom: "var(--nos-space-section-y, 64px)",
        ...style,
      }}
    >
      <div className="mx-auto max-w-6xl">{children}</div>
    </div>
  )
}
